// extracted by mini-css-extract-plugin
module.exports = {"machineIcon":"MachineIcon-module_machineIcon__3iYntJnkVHgF3P0VEI-mMN","machineImage":"MachineIcon-module_machineImage__2i0_O-OgJRhc7hLvK3t5PI"};